<template>
  <SocialstyrelsenGenericView :icd="$route.params.icd"
                              :icd-presentation-string="$route.params.icdPresentation"
                              :icd-description="$route.params.icdDescription">
  </SocialstyrelsenGenericView>
</template>

<script>
import SocialstyrelsenGenericView from '@/components/SocialstyrelsenGenericView.vue';
import {defineComponent} from "vue";

export default defineComponent({
  name: 'socialstyrelsen-generic-page',
  components: {
    SocialstyrelsenGenericView
  }
});
</script>
